import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthDialogPage } from 'src/app/services/auth/auth-ui.service.interface';

import { AuthPage } from './auth.page';

const routes: Routes = [
  {
    path: '',
    component: AuthPage
  },
  {
    path: 'signin',
    component: AuthPage,
    data: {
      page: AuthDialogPage.SignIn
    }
  },
  {
    path: 'signup/select-context',
    component: AuthPage,
    data: {
      page: AuthDialogPage.SignUp02ChooseContext
    }
  },
  {
    path: 'access-blocked',
    component: AuthPage,
    data: {
      page: AuthDialogPage.SignIn,
      showAccessBlockedMessage: true
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthPageRoutingModule {}
